import api from '../utils/api';

export interface TeacherExtraHourItem {
  ID?: number;
  Ngay: string; // ISO date (YYYY-MM-DD)
  Buoi: string; // 'Sáng' | 'Chiều' | 'Tối' or custom
  NoiDung?: string;
  KhoaLopNhom?: string;
  SoPhut?: number;
  SoBai?: number;
  SoBuoi?: number;
  Category?: string; // 'Coi thi' | 'Chấm thi' | 'Lâm sàng' | ...
}

const BASE = '/api/v1/teacher-extra-hours';

export const teacherExtraHoursService = {
  async list(params: { fromDate?: string; toDate?: string; teacherId?: string } = {}) {
    const res = await api.get(BASE, { params });
    return res.data as (TeacherExtraHourItem & { TeacherId: string; ID: number })[];
  },
  async save(item: Partial<TeacherExtraHourItem> & { ID?: number; teacherId?: string }) {
    // Backend expects lower-case body keys: ngay, buoi, ...
    const payload: any = {
      id: (item as any).ID ?? (item as any).id,
      teacherId: (item as any).teacherId,
      ngay: (item as any).Ngay ?? (item as any).ngay,
      buoi: (item as any).Buoi ?? (item as any).buoi,
      noiDung: (item as any).NoiDung ?? (item as any).noiDung,
      khoaLopNhom: (item as any).KhoaLopNhom ?? (item as any).khoaLopNhom,
      soPhut: (item as any).SoPhut ?? (item as any).soPhut,
      soBai: (item as any).SoBai ?? (item as any).soBai,
      soBuoi: (item as any).SoBuoi ?? (item as any).soBuoi,
      category: (item as any).Category ?? (item as any).category,
    };
    try {
      const res = await api.post(BASE, payload);
      return res.data as { success: boolean; id?: number; message?: string };
    } catch (err: any) {
      // Try to bubble up backend error
      const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Request failed';
      throw new Error(msg);
    }
  },
  async remove(id: number) {
    const res = await api.delete(`${BASE}/${id}`);
    return res.data as { success: boolean; message?: string };
  },
};

export default teacherExtraHoursService;
